import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles';

import { useSettingsContext } from 'src/components/settings';

import { createTheme } from './create-theme';
import { Rtl } from './with-settings/right-to-left';
import { useEffect, useLayoutEffect } from 'react';

// ----------------------------------------------------------------------

export function ThemeProvider({ themeOverrides, children, ...other }) {
  const settings = useSettingsContext();

  const theme = createTheme({
    settingsState: settings.state,
    themeOverrides,
  });

  const forceLightMode = () => {
    document.documentElement.setAttribute('data-color-scheme', 'light');
    document.documentElement.setAttribute('data-theme', 'light');
    document.body.setAttribute('data-color-scheme', 'light');
    document.body.setAttribute('data-theme', 'light');
  };

  useLayoutEffect(() => {
    forceLightMode();
  }, [settings.state.colorScheme]);

  useEffect(() => {
    forceLightMode();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-color-scheme') {
          const element = mutation.target;
          if (element.getAttribute('data-color-scheme') !== 'light') {
            forceLightMode();
          }
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-color-scheme'],
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-color-scheme'],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <ThemeVarsProvider disableTransitionOnChange theme={theme} {...other}>
      <CssBaseline />
      <Rtl direction={settings.state.direction}>{children}</Rtl>
    </ThemeVarsProvider>
  );
}
